//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'app',
    data() {
        return {
            user: {},
            storeId: 0,
            show: false
        }
    },
    created() {
        /*this.storeId = sessionStorage.getItem('storeId')
        if (this.storeId){
            this.show = true;
        }else {
            var screenWidth = window.screen.width;
            if (screenWidth > 800) {
                this.$router.push('/admin/login');
            } else {
                this.$router.push('/login');
            }

        }*/
    }
}



// WEBPACK FOOTER //
// ./src/app.vue